// Publishable key (new API key system) — sole frontend key as of 2026-06-11.
// The legacy anon key has been disabled in prod; this is the only key that works.
// The var is a string injected by Vite at build time.
export const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
